import { rupiah } from "../../lib/api";
import { Button } from "../ui/button";

export function KtStockTable({ stock, onUse, testid = "kt-stock" }) {
  if (!stock) return <div className="text-xs text-muted-foreground py-4 text-center">Memuat stok...</div>;
  if (!stock.length) return <div className="text-xs text-muted-foreground py-6 text-center" data-testid={`${testid}-empty`}>Belum ada aset diterima</div>;
  return (
    <table className="w-full text-xs" data-testid={testid}>
      <thead><tr className="text-muted-foreground border-b border-border"><th className="text-left py-1.5 font-medium">Alat</th><th className="text-right py-1.5 font-medium">Diterima</th><th className="text-right py-1.5 font-medium">Terpakai</th><th className="text-right py-1.5 font-medium">Retur</th><th className="text-right py-1.5 font-medium">Sisa</th><th className="text-right py-1.5 font-medium">Nilai Sisa</th>{onUse && <th />}</tr></thead>
      <tbody>
        {stock.map((s) => (
          <tr key={s.name} className="border-b border-border/50" data-testid={`${testid}-row-${s.name.replace(/\W+/g, "-")}`}>
            <td className="py-1.5 font-medium">{s.name}</td>
            <td className="py-1.5 text-right font-mono">{s.received}</td>
            <td className="py-1.5 text-right font-mono text-muted-foreground">{s.used}</td>
            <td className="py-1.5 text-right font-mono text-rose-500">{s.returned || 0}</td>
            <td className={`py-1.5 text-right font-mono font-bold ${s.remaining <= 0 ? "text-rose-500" : "text-emerald-500"}`}>{s.remaining}</td>
            <td className="py-1.5 text-right font-mono text-muted-foreground">{s.price ? rupiah(s.price * s.remaining) : "-"}</td>
            {onUse && <td className="py-1 text-right"><Button size="sm" variant="outline" className="h-7 text-[11px]" disabled={s.remaining <= 0} onClick={() => onUse(s.name)} data-testid={`${testid}-use-${s.name.replace(/\W+/g, "-")}`}>Pasang</Button></td>}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
